<h5 mat-dialog-title class="modal_title flex">
    {{"CAMPAIGN.RANDOMIZER" | translate}}
    <mat-icon svgIcon="mat_outline:close"
        class="ml-auto max-w-[22px] max-h-[22px] text-[#0b0d13] font-medium cursor-pointer leading-none min-w-[22px] text-[22px] min-h-[22px]"
        mat-dialog-close></mat-icon>
</h5>
<mat-dialog-content class="modal_body">
    <div class="text-md font-normal text-[#7D7F86] leading-5 mb-4">
        {{"CAMPAIGN.MAKE_YOUR_CONTENT_DYNAMIC" | translate}}
    </div>
    <ng-container *ngFor="let input of _mapping?.inputs; let i = index">
        <mat-form-field class="w-full fuse-mat-dense mb-3"
            subscriptSizing="dynamic" floatLabel="always">
            <mat-label class="form_label">{{ input?.label |
                translate : {activeStep: i+1} }}</mat-label>
            <input type="text" [id]="'variant_' + i" class="w-full form_input rounded-3" [placeholder]="input?.hint_text ? (input?.hint_text | translate) : ('INBOX_PAGE.ENTER_TEXT_HERE' | translate)" [(ngModel)]="input.value" matInput />
        </mat-form-field>
    </ng-container>
    <a *ngIf="_mapping?.inputs?.length < 5" class="text-primary text-md font-medium leading-normal mt-4 cursor-pointer" (click)="addVariant()"> + {{"CAMPAIGN.ADD_VARIANT" | translate}} </a>
</mat-dialog-content>
<mat-dialog-actions align="start" class="form_action">
    <btn-loading type="submit" color="primary" (click)="doAddSpinTax()"
        btnClass="text-md text-custom font-medium leading-[14px] min-h-[34px] max-h-[34px] rounded">
        {{"LEAD_MANAGEMENT.ADD" | translate}}
    </btn-loading>
    <button matRipple class="cancel_btn" mat-dialog-close>{{ "GENERAL.CANCEL" | translate
        }}</button>
</mat-dialog-actions>
